import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

/**
 * Top bar: sidebar toggle on the left, account menu on the right.
 * (Template extras — mega menu, search, notifications, fullscreen, theme
 * customizer — were removed; none of them had a use in this product.)
 */
const Header = (props) => {
  const toggleSidebar = () => {
    const body = document.body;
    // Viewport, not monitor width: a narrow desktop window behaves like mobile.
    if (window.matchMedia("(max-width: 991.98px)").matches) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  };

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex">
          <button
            type="button"
            onClick={toggleSidebar}
            className="btn btn-sm px-3 font-size-16 header-item"
            id="vertical-menu-btn"
            aria-label={props.t("Abrir ou fechar menu")}
            aria-controls="sidebar-menu"
          >
            <i className="fa fa-fw fa-bars" aria-hidden="true" />
          </button>
        </div>
        <div className="d-flex">
          <ProfileMenu />
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Header);
